// Import createMiddleware and a targets
import { createMiddleware } from 'redux-beacon';
import GoogleAnalyticsGtag from '@redux-beacon/google-analytics-gtag';
import { logger } from 'redux-beacon/extensions/logger';
// import { MixpanelAnalytics } from 'tracking/mixpanelBeconTarget';
import { Segment } from 'redux-beacon/targets/segment';

// Import event maps.
import commonEventsMap from 'tracking/commonEventMap';
import googleEventsMap from 'tracking/googleEventMap';
import segmentEventsMap from 'tracking/segmentEventMap';
// import mixpanelEventsMap from 'tracking/mixpanelEventMap';

// Create the middleware
export default [
    createMiddleware(Object.assign({}, commonEventsMap, segmentEventsMap),
        Segment,
        { logger }),
    createMiddleware(Object.assign({}, commonEventsMap, googleEventsMap),
        GoogleAnalyticsGtag,
        { logger }),
    // Mixpanel disabled 1/2
    // createMiddleware(Object.assign({}, commonEventsMap, mixpanelEventsMap),
    //     MixpanelAnalytics,
    //     { logger })
];



// WEBPACK FOOTER //
// ./src/middleware/tracking.js